import { Injectable } from '@angular/core';
import { I18ConfigService } from './I18-config.service';
import { AirportListService } from '../airport/airport-list.service';
import { ActivatedRoute } from '@angular/router';


interface DefaultParams {
  key: string;
  pid: string;
  platform: string;
  airport: string;
  lang: string;
  currency: string;
  userid?: string | number;
}
@Injectable({
  providedIn: 'root'
})
export class EnvironmentConfigService {
  private defaultParams: any;
  baseUrl = 'https://dev-api.travelx.ai';
  getRetailers = '/api/getRetailers';
  getFoodMenuOptions = '/api/getFoodMenuOptions';
  getFoodMenu = '/api/getFoodMenu';
  updateCartState = '/api/updateCartState';
  getCartList = '/api/getCartList';
  checkoutCart = '/api/checkoutFood';
  autoCheckoutForm = '/api/autocheckoutform';
  checkoutRetailCart = '/api/checkoutcart';
  gettimeSlots = '/api/getTimeSlots';
  getProductValidation = '/api/getProductValidation';
  getRetailersDetailsV2 = '/api/getRetailersDetailsV2';
  searchByStores = '/api/searchByStores';
  getProductDetails = '/api/getProductDetails';
  getFinalPrice = '/api/checkPrice';

  constructor(private i18ConfigService: I18ConfigService, private airportService: AirportListService, private activatedRoute: ActivatedRoute) {
  }
  getDefaultApiParams() {
    this.defaultParams = {
      key: localStorage.getItem("pid") !== 'undefined' ? localStorage.getItem("key") : 'dhjdfdbdfkdf',
      pid: localStorage.getItem("pid") !== 'undefined' ? localStorage.getItem("pid") : 'ddmf',
      platform: 'web',
      airport: this.airportService.getSelectedAirport(),
      lang: this.i18ConfigService.getLanguage(),
      currency: this.i18ConfigService.getCurrency()
    } as DefaultParams;
    let userId = localStorage.getItem('userId');
    if (typeof userId !== 'undefined' && userId !== null) {
      this.defaultParams.userid = userId;
    }
    return this.defaultParams;
  }

  getRetailersApi() {
    return this.baseUrl + this.getRetailers;
  }

  getFoodMenuOptionsApi() {
    return this.baseUrl + this.getFoodMenuOptions;
  }

  getFoodMneuApi() {
    return this.baseUrl + this.getFoodMenu;
  }

  updateCartStateApi() {
    return this.baseUrl + this.updateCartState;
  }

  getCartListApi() {
    return this.baseUrl + this.getCartList;
  }

  getFinalPriceApi() {
    return this.baseUrl + this.getFinalPrice;
  }

  checkoutCartApi() {
    return this.baseUrl + this.checkoutCart;
  }

  autoCheckoutFormApi() {
    return this.baseUrl + this.autoCheckoutForm;
  }

  checkoutRetailCartApi() {
    return this.baseUrl + this.checkoutRetailCart;
  }

  getTimeSlotsApi() {
    return this.baseUrl + this.gettimeSlots;
  }

  getProductValidationApi() {
    return this.baseUrl + this.getProductValidation;
  }

  getRetailersDetailsV2Api() {
    return this.baseUrl + this.getRetailersDetailsV2;
  }

  getProductDetailsApi() {
    return this.baseUrl + this.getProductDetails;
  }

  searchByStoresApi() {
    return this.baseUrl + this.searchByStores;
  }




}
